<template>
  <div class="search-wrapper">
    <home-common-search :from="'search'" ref='header' :value="keywords"></home-common-search>
    <div class="search-body">

      <div class="list current-search" v-if='currenKeywords.length > 0'>
        <div class="list-header">
          <span>{{ $t('Recent searches') }}</span>
          <img src="../../../assets/image/home/home-search-delete1.png" v-on:click='deleteCurrent()'>
        </div>
        <ul>
          <li class="item" v-for="(item, index) in currenKeywords" v-on:click='getKey(item)' :key="index">{{ item }}</li>
        </ul>
      </div>

      <div class="list hot-wrapper" v-if="hotKeywords[0] !== ''">
        <div class="list-header">
          <span>{{ $t('popular searches') }}</span>
        </div>
        <ul>
          <li class="item" v-for='(item, index) in hotKeywords' :key='index' v-on:click='getKey(item)'>{{ item }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import HomeCommonSearch from '../common/HomeCommonSearch'
import { searchKeywordList } from '../../../api/homesearch'
export default {
  data() {
    return {
      hotKeywords: [],
      currenKeywords: [],
      keywords: this.$store.state.homesearch.currentKey ? this.$store.state.homesearch.currentKey : ''
    }
  },
  components: {
    HomeCommonSearch
  },
  computed: {
    ...mapState({
      currentKey: state => state.homesearch.currentKey
    })
  },

  created() {
    this.getHotKeywords()
    this.getCurrentKey()
  },

  methods: {
    ...mapMutations({
      'changeKey': 'changeKey'
    }),

    getHotKeywords() {
      searchKeywordList().then(res => {
        this.hotKeywords = Object.assign([], res.result.list, this.hotKeywords)
      })
    },

    getKey(item) {
      if (item.content) {
        this.keywords = item.content
      } else {
        this.keywords = item
      }
      this.changeKey(this.keywords)
      this.$refs.header.goSearch(this.keywords)
    },

    deleteCurrent() {
      this.utils.save('keyword', [])
      this.currenKeywords = this.utils.fetch('keyword')
    },

    getCurrentKey() {
      this.currenKeywords = this.utils.fetch('keyword')
    }
  }
}
</script>

<style lang='scss' scoped>
.search-wrapper {
  height: auto;
  width: auto;
  background-color: #fff;

  .search-body {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: $pageSpace;
    padding-right: $pageSpace;

    div.list {
      margin-bottom: 1.5rem;

      .list-header {
        display: flex;
        justify-content: space-between;
        align-content: center;
        align-items: center;

        span {
          color: #333;
          font-size: $h3;
          background: url('../../../assets/image/home/home-search-history.png') no-repeat left center;
          background-size: 0.8rem;
          padding-left: 1.25rem;
          align-self: flex-end;
        }

        img {
          width: 0.8rem;
          cursor: pointer;
        }
      }

      ul {
        display: flex;
        padding-top: 0.65rem;
        flex-wrap: wrap;

        li {
          cursor: pointer;
          padding: 0.4rem;
          background-color: #F4F4F4;
          color: $descTextColor;
          font-size: $fontSize;
          margin-right: 0.8rem;
          margin-bottom: 0.8rem;
          border-radius: .2rem;
        }
      }
    }

    div.hot-wrapper {
      .list-header {
        span {
          background: url('../../../assets/image/home/home-search-hot.png') no-repeat left center;
          background-size: 0.8rem;
        }
      }
    }
  }
}
</style>
